import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-remedial-classes',
  templateUrl: './remedial-classes.component.html',
  styleUrls: ['./remedial-classes.component.scss']
})
export class RemedialClassesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
